import React, { useEffect, useState } from "react";
import { CenterBox } from "./Utils";
import { useParams } from "react-router-dom";
import SignIn from "./SignIn.js";
import * as Sentry from "@sentry/react";

import Cookies from "universal-cookie";
import { AFFILIATES } from "../../src/shared/constants";

function Affiliate(props) {
  const [user, setUser] = useState(null);
  const [redirected, setRedirected] = useState(false);
  const [loginError, setLoginError] = useState(false);

  let { code } = useParams();

  useEffect(() => {
    const cookies = new Cookies();

    // Set the invite code so that if user decides to use email sign they can generate a link directly with this code
    if (code) {
      // window.localStorage.setItem("inviteUrl", encodeURI(window.location.href + "#redirect"));
      cookies.set("affiliate", code, {
        maxAge: 60 * 60 * 24 * 365,
        path: "/",
      });
    }

    if (window.location.hash === "#redirect") {
      // we know they came back from signing in
      // give it a moment to wait to check
      setRedirected(true);
      window.location.hash = "";

      Sentry.setContext("affiliateRedirect", {
        code: code,
      });
    }
  }, []);

  const invalid = !Object.keys(AFFILIATES).includes(code);
  let message;
  if (!invalid) {
    message = AFFILIATES[code].message;
  }
  const description = AFFILIATES[code].description || "Get started by signing up";

  return (
    <>
      {invalid && (
        <CenterBox>
          <h1>Looks like you clicked on an invalid invite link</h1>
          <p>If you feel this is a mistake, please contact the person that has given you this link.</p>
        </CenterBox>
      )}

      {!invalid && (
        <>
          {redirected && (
            <CenterBox noTitle={true}>
              <h2>Checking account...</h2>
            </CenterBox>
          )}
          {!redirected && (
            <>
              <SignIn
                title={message}
                description={description}
                error={loginError}
              />
            </>
          )}
        </>
      )}
    </>
  );
}

export default Affiliate;
